<script setup lang="ts">
import useCurrentUserFavoriteComposable from '@src/favorite/composable/current-user-favorite-composable.ts';
import FavoriteEntry from '@src/favorite/components/favorite-entry.vue';
import IconTooltip from '@components/icons/icon-tooltip.vue';
import { createModalAbort } from '@utils/modal-util.ts';
import { EditFavoriteRequest } from '@src/api/interface/request/edit-favorite-request.ts';
import EditFavorites from '@src/favorite/components/edit-favorites.vue';
import Icon from '@components/icons/icon.vue';
import mobileDetectStore from '@src/application/store/mobile-detect-store.ts';
import showSideBarStore from '@src/application/store/show-side-bar-store.ts';

const { favorites, loadFavoritesByCurrentUser } = useCurrentUserFavoriteComposable();
const isMobile = mobileDetectStore.isMobile.data;

loadFavoritesByCurrentUser();

function editFavoriteEntries() {
    if (isMobile) {
        showSideBarStore.showSideBar.data = false;
    }
    createModalAbort<Array<EditFavoriteRequest>>(
        'Favoriten bearbeiten',
        EditFavorites,
        'saved',
        null,
        '1',
    );
}
</script>

<template>
    <div v-if="favorites && favorites.length > 0" :class="$style.favorites">
        <div :class="$style.headline" @click="editFavoriteEntries">
            <p>Favoriten</p>
            <Icon v-if="isMobile" icon="edit" icon-color="white"/>
            <IconTooltip
                v-else
                icon="edit"
                icon-color="white"
                tooltip="Favoriten bearbeiten"
                position="right"
            />
        </div>
        <FavoriteEntry
            v-for="favorite in favorites"
            :favorite="favorite"
        />
    </div>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

.headline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .75em .75em .75em 1em;
    color: #fff;
    line-height: 1.3;
    background-color: $primary-background-dark-mode;

    &:hover {
        cursor: pointer;
    }
}

.favorites {
    margin-top: .5em;
}
</style>
